import { Typography } from '@mui/material'
import {
  getPanelHistory,
  useHistoryCustomBack,
  useNavigate,
  usePanelHistoryTop,
} from 'weblite-router'
import { NAVIGATION_BAR_HEIGHT } from '$common/navigation-bar'
import { StaticWappPanel } from '$comp/static-wapp-panel'
import { StaticPanelWappId } from '$logic/wapp-panels'
import { HomePanel } from '$scenes/router-panels/router-panels'
import { PageWithAppBar } from '$common/page-with-app-bar'
import { AppBarBackTitle } from '$common/app-bar/app-bar-back-title'
import { switchToRoomList } from '$logic/router'
import { t } from '$i18n'
import { usePreventPreLoad } from '$hooks/use-prevent-preload'
import { VisibilityHandler } from './components/visibility-handler'

export function Kooleh() {
  const navigate = useNavigate()

  const homePanelState = usePanelHistoryTop('home')?.state
  const isTop = homePanelState?.tab === 'kooleh'

  const preventPreLoad = usePreventPreLoad(isTop)

  useHistoryCustomBack(
    () => {
      const panelHistory = getPanelHistory('kooleh')

      if (panelHistory.length > 1) navigate(-1)
      else
        HomePanel.navigate('home', {
          replace: true,
          absolute: true,
          data: { tab: 'roomList' },
        })
    },
    [],
    isTop,
  )

  if (preventPreLoad) return null
  return (
    <VisibilityHandler zIndex={1} considerIOSNotch>
      <PageWithAppBar
        appBar={
          <AppBarBackTitle
            title={
              <Typography variant="subtitle1" color="neutral800">
                {t('navigationBar.backpack')}
              </Typography>
            }
            onBack={switchToRoomList}
          />
        }
      >
        <StaticWappPanel wappId={StaticPanelWappId.KOOLEH} />
      </PageWithAppBar>
      {/*<Box sx={{ height: `calc(100% - ${NAVIGATION_BAR_HEIGHT}px)` }}>*/}
      {/*  <StaticWappPanel wappId={StaticPanelWappId.KOOLEH} />*/}
      {/*</Box>*/}
    </VisibilityHandler>
  )
}
